import type {ReactElement, ReactNode} from 'react';
import ContentBlock from '@components/CoverPage/ContentBlock/ContentBlock';
import ResendCode from '@components/UserVerificationCode/ResendCode/ResendCode';
import Background from '@components/CoverPage/Background';

interface Props {
    children: ReactNode;
}

export default function ResendCodeBlock(props: Props): ReactElement<Props> {
    return (
        <Background>
            <ContentBlock>
                <ResendCode>{props.children}</ResendCode>
            </ContentBlock>
        </Background>
    );
}
